import { useState, useEffect } from 'react'
import { Toast, subscribeToToasts } from './toastStore'

export function Toaster() {
  const [toastList, setToastList] = useState<Toast[]>([])

  useEffect(() => {
    return subscribeToToasts((newToasts) => setToastList(newToasts))
  }, [])

  if (toastList.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 left-4 sm:left-auto z-50 space-y-2 pointer-events-none">
      {toastList.map((toast) => (
        <div
          key={toast.id}
          className={`
            px-4 sm:px-5 py-3 sm:py-4 rounded-xl shadow-2xl max-w-sm mx-auto sm:mx-0 animate-slide-up backdrop-blur-sm border pointer-events-auto
            ${toast.type === 'success' ? 'bg-green-500/90 text-white border-green-400/30' : ''}
            ${toast.type === 'error' ? 'bg-red-500/90 text-white border-red-400/30' : ''}
            ${toast.type === 'info' ? 'bg-primary-500/90 text-white border-primary-400/30' : ''}
          `}
        >
          <p className="text-xs sm:text-sm font-semibold break-words">{toast.message}</p>
        </div>
      ))}
    </div>
  )
}
